module.exports = __webpack_public_path__ + "static/media/icono-telef.c341f8ed.svg";